import { HistoryStackEntry } from "../types/HistoryStackEntry";
import { NavigationEventType } from "../types/NavigationEventType";
import { PageEnterDetail } from "../types/PageEnterDetail";

interface ProcessBackOrForwardArgs {
  emitEvent: (type: NavigationEventType, detail?: PageEnterDetail) => void;
  fscriptId: string;
  HistoryIndexKey: string;
  historyStack: HistoryStackEntry[];
  HistoryStackKey: string;
  lastKnownIndex: number;
  fscriptSessionId: string;
}

export const processBackOrForward = ({
  emitEvent,
  fscriptId: _fscriptId,
  HistoryIndexKey,
  historyStack,
  HistoryStackKey,
  lastKnownIndex,
  fscriptSessionId,
}: ProcessBackOrForwardArgs) => {
  const fscriptId = _fscriptId || history.state.fscriptId;

  // Find the page in history stack by fscriptId
  const targetIndex = historyStack.findIndex(
    (entry) => entry.fscriptId === fscriptId
  );

  let newCurrentIndex = lastKnownIndex;

  console.log("processBackOrForward", { fscriptId, targetIndex });

  if (targetIndex === -1) {
    // Page not found in history stack
    newCurrentIndex = lastKnownIndex + 1;
    historyStack = historyStack.slice(0, newCurrentIndex);

    setTimeout(() => {
      historyStack.push({
        url: location.href,
        fscriptId: fscriptId,
      });

      localStorage.setItem(
        HistoryStackKey + fscriptSessionId,
        JSON.stringify(historyStack)
      );
      localStorage.setItem(
        HistoryIndexKey + fscriptSessionId,
        newCurrentIndex.toString()
      );
    }, 1);

    emitEvent("page_load", "back_forward_to_unknown_history");

    return;
  }

  let eventTypeToEmit: NavigationEventType;
  let eventDetailToEmit: PageEnterDetail | undefined;

  // Determine direction based on index comparison
  if (targetIndex < lastKnownIndex) {
    eventTypeToEmit = "browser_back";
  } else if (targetIndex > lastKnownIndex) {
    eventTypeToEmit = "browser_forward";
  } else {
    eventTypeToEmit = "page_load";
    eventDetailToEmit = "history_jump_to_same_effective_index";
  }

  newCurrentIndex = targetIndex;

  localStorage.setItem(
    HistoryStackKey + fscriptSessionId,
    JSON.stringify(historyStack)
  );
  localStorage.setItem(
    HistoryIndexKey + fscriptSessionId,
    newCurrentIndex.toString()
  );

  emitEvent(eventTypeToEmit, eventDetailToEmit);
};
